export default {
  dateFormat: 'DD/MM/YYYY',
  languages: {
    en: 'English',
    fr: 'Français',
    nl: 'Nederlands',
  },

  products: {
    en: 'https://products.remeha.be/site/index/catalog/type/prof/language/en/web_code/remeha_calenta_solo_15s_25s_35s',
    nl: 'https://products.remeha.be/site/index/catalog/type/prof/language/nl/web_code/remeha_calenta_solo_15s_25s_35s',
    fr: 'https://products.remeha.be/site/index/catalog/type/prof/language/fr/web_code/remeha_calenta_solo_15s_25s_35s',
  },

  projects: {
    types: ['new', 'old', 'renovated'],
    cycles: {
      max: 3,
    },
    heating: {
      max: 61,
      min: 0,
    },
  },
};



// WEBPACK FOOTER //
// ./js/utils/config/index.js